import { useRouter } from 'next/router';

type SessionType = 'VIDEO' | 'AUDIO';

export default function useSessionType() {
  const router = useRouter();
  const {
    query: { on: sessionType }
  } = router;

  return sessionType as SessionType;
}
